import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  BuildingPayloadSchema,
  buildingPayloadSchema,
  useBuilding,
} from "@/api/building";
import { Loading } from "@/components/ui/loading";
import { BuildingFormFields } from "./BuildingFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";

export function BuildingDetailForm({ id }: { id: string }) {
  const {
    data: building,
    isPending: isLoadingData,
    isError,
  } = useBuilding({
    id,
  });
  const form = useForm<BuildingPayloadSchema>({
    resolver: zodResolver(buildingPayloadSchema),
    defaultValues: {
      categoryBizpass: building?.categoryBizpass,
      dwellingType: building?.dwellingType,
    },
    values: building,
  });

  if (isLoadingData) {
    return <Loading />;
  }

  if (!building) {
    return <div>Building not found</div>;
  }

  if (isError) {
    return <div>Failed to load building</div>;
  }

  return (
    <FormContainer form={form}>
      <BuildingFormFields isDisabled />
      <div className="ml-auto">
        <Anchor href="/master-data/category-bizzpass" mood="axiata-blue">
          Back
        </Anchor>
      </div>
    </FormContainer>
  );
}
